import {atom} from 'recoil';
import {enrollmentEventType} from '../../types/event';

export const enrollEvent = atom<enrollmentEventType>({
  key: 'enrollEvent',
  default: undefined,
});
